import {
  PrimaryButton,
  Label,
  Stack,
  IIconProps,
  registerIcons,
  IStackStyles,
} from "@fluentui/react";

import { useNavigate } from "react-router-dom";
import { DoubleChevronLeftIcon, QandAIcon } from "@fluentui/react-icons-mdl2";

import React, { useEffect, useMemo, useState } from "react";

import ProjectInvitationService from "../../common/api-services/ProjectInvitationService";

import styles from "./privacy.module.scss";
import { IPrivacy } from "../../common/models/IPrivacy";

const Privacy = () => {
  let navigate = useNavigate();

  registerIcons({
    icons: {
      QandAIcon: <QandAIcon />,
      DoubleChevronLeftIcon: <DoubleChevronLeftIcon />,
    },
  });

  const tacContentStyles: IStackStyles = {
    root: {
      backgroundColor: `#eeeeee`,
      //outline: `1px solid red`,
      width: `100%`,
      height: `100%`,
      overflowY: `auto`,
      padding: `0px 15px`,
      maxHeight: `calc(100vh - 300px)`,
    },
  };

  const service = useMemo(() => new ProjectInvitationService(), []);

  const projectFaqIcon: IIconProps = {
    iconName: "QandAIcon",
    styles: {
      root: [
        {
          selectors: {
            ">span": {
              verticalAlign: "top",
            },
          },
        },
      ],
    },
  };

  const [privacy, setPrivacy] = useState<IPrivacy>({ title: "", content: "" });

  const onDownloadFaq = (
    event: any,
    from: string,
    blobUrl: any,
    fileName?: string
  ) => {
    service.GetFaq().then((data) => {
      if (
        data.faqDocumentFetchSuccess == null ||
        data.faqDocumentFetchSuccess == false
      ) {
        navigate(`/notfound`);
      } else {
        fetch(`data:application/pdf;base64,${data.faqDocumentData}`)
          .then(function (base64resp) {
            if (base64resp) {
              return base64resp.blob();
            }
          })
          .then(function (faqBlob) {
            if (faqBlob) {
              //console.log("Filename:" + data.reportFilename)
              const faqBlobUrl = URL.createObjectURL(faqBlob);
              let alink = document.createElement("a");
              alink.href = faqBlobUrl;
              alink.download = data.faqDocumentFilename ?? "FAQ.pdf";
              alink.style.display = "none";
              document.body.append(alink);
              alink.dispatchEvent(
                new MouseEvent("click", {
                  bubbles: true,
                  cancelable: true,
                  view: window,
                })
              );
            }
          });
      }
    });
  };
  useEffect(() => {
    service.GetPrivacyPolicy().then((data: IPrivacy) => {
      setPrivacy(data);
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const backIcon: IIconProps = {
    iconName: "DoubleChevronLeftIcon",
    styles: {
      root: [
        {
          selectors: {
            ">span": {
              verticalAlign: "top",
            },
          },
        },
      ],
    },
  };

  return (
    <Stack>
      <Stack horizontal horizontalAlign="space-between">
        <PrimaryButton
          text="Back"
          className={styles.buttonNewProject}
          iconProps={backIcon}
          onClick={(event) => navigate(-1)}
        />
        <PrimaryButton
          text="FAQ"
          className={styles.buttonNewProject}
          iconProps={projectFaqIcon}
          onClick={(event) => onDownloadFaq(event, `click`, ``, ``)}
        />
      </Stack>
      <Stack horizontal horizontalAlign="space-between">
        <Stack horizontal horizontalAlign="start">
          <Label className={styles.PageHeader}>{privacy?.title}</Label>
        </Stack>
      </Stack>
      <Stack>
        <hr className={styles.horizontalLine}></hr>
      </Stack>

      <Stack horizontal>
        <Stack styles={tacContentStyles}>
          <div
            id="tacContent"
            className="tacContent"
            style={{ padding: "0px 15px" }}
            dangerouslySetInnerHTML={{
              __html: privacy.content,
            }}
          ></div>
        </Stack>
      </Stack>
      <Stack>
        <hr className={styles.horizontalLine}></hr>
      </Stack>
    </Stack>
  );
};

export default Privacy;
